import IconButton from "../../common/IconButton";
export default IconButton;